import { t } from '@lingui/core/macro';
import { QuoteRequestStatus } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

export function formatQuoteRequestStatus(
    status: QuoteRequestStatus | null,
    { perspective }: { perspective: 'sender' | 'receiver' },
): string {
    if (status === null) {
        return t`No link`;
    }

    // This is the perspective of the EMS
    if (perspective === 'sender') {
        switch (status) {
            case QuoteRequestStatus.Received:
                return t`Received`;
            case QuoteRequestStatus.Sent:
                return t`Sent`;
            case QuoteRequestStatus.Overdue:
                return t`Overdue`;
            case QuoteRequestStatus.Discarded:
                return t`Discarded`;
            case QuoteRequestStatus.NotSent:
                return t`Draft`;
        }
    }

    // This is the perspective of the supplier portal user
    if (perspective === 'receiver') {
        switch (status) {
            case QuoteRequestStatus.Received:
                return t`Submitted`;
            case QuoteRequestStatus.Sent:
                return t`Open`;
            case QuoteRequestStatus.Overdue:
                return t`Overdue`;
            case QuoteRequestStatus.Discarded:
                return t`Discarded`;
            case QuoteRequestStatus.NotSent:
                return t`Draft`;
        }
    }

    assertUnreachable(perspective);
}
